<template>
  <div styleName="modal" v-if="modalShow">
    <div styleName="modalInner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'

export default {
  name: 'modal',
  mixins: [CSSModules(styles)],
  computed: {
    modalShow () {
      return this.$store.state.chatBox.modal
    }
  }
}
</script>
